import MenuBookIcon from "@mui/icons-material/MenuBook";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctoralPrograms from "./List";
import CreateDoctoralPrograms from "./Create";
import EditDoctoralPrograms from "./Edit";
import ShowDoctoralPrograms from "./Show";

export const resources = {
  isMenu: true,
  icon: <MenuBookIcon />,
  name: `${DoctoralServicePath}doctoral-programs`,
  title: "Докторантски програми",
  list: <ListDoctoralPrograms />,
  create: <CreateDoctoralPrograms />,
  createPermission: permissions.canCreateDoctoralPrograms,
  edit: <EditDoctoralPrograms />,
  editPermission: permissions.canUpdateDoctoralPrograms,
  show: <ShowDoctoralPrograms />,
  permission: permissions.canPreviewDoctoralPrograms,
};
